export enum PaymentMethod {
  PIX = "feev_pix",
  CreditCard = "braspag_cartao",
  Boleto = "feev_boleto",
}
